import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store';
import { clearScreenLimit } from '@/store/slices/screenSlice';

/**
 * Blocking modal shown when a playback-start request returned
 * 403 SCREEN_LIMIT_REACHED. Reuses the `.join-prompt` modal styling. Mounted
 * once globally in App.tsx; driven by the `screen` redux slice.
 */
export function ScreenLimitModal(): JSX.Element | null {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const open = useAppSelector((s) => s.screen.limitReached);
  if (!open) return null;

  const manage = (): void => {
    dispatch(clearScreenLimit());
    navigate('/account#screens');
  };
  const dismiss = (): void => { dispatch(clearScreenLimit()); };

  return (
    <div className="join-prompt__backdrop" role="presentation">
      <div className="join-prompt" role="dialog" aria-modal="true" aria-labelledby="screen-limit-title">
        <h2 id="screen-limit-title" className="join-prompt__title">{t('watch.screenLimit.title')}</h2>
        <p className="join-prompt__body">{t('watch.screenLimit.body')}</p>
        <div className="join-prompt__actions">
          <button type="button" className="btn" data-testid="screen-limit-manage" onClick={manage}>
            {t('watch.screenLimit.manage')}
          </button>
          <button type="button" className="btn-ghost" data-testid="screen-limit-dismiss" onClick={dismiss}>
            {t('watch.screenLimit.dismiss')}
          </button>
        </div>
      </div>
    </div>
  );
}
